// extracted by mini-css-extract-plugin
export default {"Container":"Index_Container__dvTCd","Editor":"Index_Editor__znVf5","expandFromTopLeft":"Index_expandFromTopLeft__rgki6","Header":"Index_Header__mvEOo"};